import "./index.less";
import "../../html/tpl/header";
import "../../html/tpl/footer";
import { post, get } from "../../js/http";
import { setMediaLen } from "../../js/util";
console.log("首页");

$(document).ready(function () {
  let indexCarouselTpl = require("./indexCarousel.art");
  // 获取banner
  post("/ApiHome/ApiAction?_ControlName=GetBannerInfoByPC", {
    AutoID: 3049,
    FromCompanyID: 100,
    PackName: "CallMe.PC"
  }).then(res => {
    if (res.ReturnStatus) {
      $("#swiper-banner").html(
        indexCarouselTpl({ bannerList: res.Data.OnlyOneData })
      );
      layui.use(["carousel"], function () {
        var b = 1920 / 286; //我的图片比例
        //获取浏览器宽度
        var W = $(window).width();
        var H = $(window).height();
        var carousel = layui.carousel;
        carousel.render({
          elem: "#swiper-banner",
          width: "100%", //设置容器宽度
          height: (W / b).toString() + "px", //按比例和浏览器可视页面宽度来获取高度
          interval: 5000
        });
        $(window).resize(function () {
          let swiperW = $("#swiper-banner").width();
          $("#swiper-banner").height((swiperW * 286) / 1920);
        });
      });
    }
  });
  let docData = []
  post("/ApiHome/ApiAction?_ControlName=GetSystemConfigAllByPC", {
    ParentID: 19600
  }).then(res => {
    if (res.ReturnStatus && res.Data && res.Data.OnlyOneData && res.Data.OnlyOneData.length) {
       docData = res.Data.OnlyOneData
      //  $($($("#notice-wrap").children()[0]).children()[0]).text(docData[0].Title)
       $($($("#notice-wrap").children()[1]).children()[0]).html(docData[0].Title) && $($($("#notice-wrap").children()[1]).children()[1]).html(docData[0].LastUpdateTime.substring(0,10))
       docData.length > 1 && $($($("#notice-wrap").children()[2]).children()[0]).html(docData[1].Title) && $($($("#notice-wrap").children()[2]).children()[1]).html(docData[1].LastUpdateTime.substring(0,10))  
    }
    else{
      $("#notice-wrap").hide();
    }
  });
  // 获取公告 20200707取消 Karma
  // post("/ApiHome/ApiAction?_ControlName=GetInformationConfigByPC", {
  //   KeyName: "PcNotice"
  // }).then(res => {
  //   if (res.ReturnStatus) {
  //     let noticeTpl = require("./notice.art");
  //     var noticeHtml = noticeTpl(res.Data);
  //     $("#notice-wrap").html(noticeHtml);

  //     $("#notice-wrap").click(function() {
  //       layui.use(["layer"], function() {
  //         var $ = layui.jquery,
  //           layer = layui.layer;
  //         layer.open({
  //           type: 1,
  //           skin: "layer-custom",
  //           area: ["500px", ""],
  //           title: "",
  //           id: "noticeCon",
  //           closeBtn: 2,
  //           content: $("#notice-con"),
  //           end: function() {
  //             $("#notice-con").hide();
  //           }
  //         });
  //       });
  //     });
  //   } else {
  //     $("#notice-wrap").hide();
  //   }
  // });

  // 咨询服务
  let advisoryTemplate = require("./service_advisory.art");
  //获取推荐咨询服务
  getAdvisory({ Position: 1001, PageSize: 15 });

  $("#advisory ul.km-service-type li").on("click", function () {
    var index = $(this).index();
    $(this)
      .addClass("active")
      .siblings()
      .removeClass("active");
    if (index == 0) {
      //推荐
      getAdvisory({ Position: 1001, PageSize: 15 });
    } else if (index == 1) {
      //最新
      getAdvisory({ Position: 1002, PageSize: 15 });
    } else if (index == 2) {
      //猜你喜欢
      getAdvisory({ Position: 1004, PageSize: 15 });
    }
  });

  //获取咨询服务
  function getAdvisory(data) {
    post("/ApiHome/ApiAction?_ControlName=GetConsultingService", data).then(
      res => {
        if (res.Data.OnlyOneData && res.Data.OnlyOneData.length) {
          res.Data.OnlyOneData.forEach(item => {
            item.transMediaLength = setMediaLen(item.MediaLength);
          });
          var indexHtml = advisoryTemplate(res.Data);
          document.getElementById("km-service-content").innerHTML = indexHtml;
        }
        var voiceList = document.getElementsByClassName("voice-box");
        // for (var i = 0; i < voiceList.length; i++) {
        //   voiceList[i].onclick = function() {
        //     console.log($(this));
        //     //注意涉及到这个对象不能使用voiceList[i],要用this代替
        //     $("#audioPlayer").attr("src", this.getAttribute("data-media"));
        //     $("#audioPlayer")[0].play();
        //   };
        // }
      }
    );
  }

  //认证专家
  getExpert({ PageSize: 15 });

  //获取认证专家
  function getExpert(data) {
    post("/ApiHome/ApiAction?_ControlName=GetExpertCallList", data).then(
      res => {
        if (res.Data.ExpertType && res.Data.OnlyOneData) {
          var expertTemplate = require("./expert.art");
          let expertListData = res.Data;
          if (expertListData.OnlyOneData.length) {
            expertListData.OnlyOneData.forEach(item => {
              if (item.Interest) {
                item.newInterestList = item.Interest.split(",");
              }
            });
          }
          document.getElementById("expert").innerHTML = expertTemplate(
            expertListData
          );
          if (data.ExpertType) {
            $("#expert ul.km-service-type li").each((index, item) => {
              if (item.getAttribute("data-id") == data.ExpertType) {
                $(item)
                  .addClass("active")
                  .siblings()
                  .removeClass("active");
              }
            });
          } else {
            $($("#expert ul.km-service-type li")[0])
              .addClass("active")
              .siblings()
              .removeClass("active");
          }

          addExpertEvent();
        }
      }
    );
  }

  function addExpertEvent() {
    $("#expert ul.km-service-type li").click(function () {
      var index = $(this).index();
      $(this)
        .addClass("active")
        .siblings()
        .removeClass("active");
      getExpert({ ExpertType: this.getAttribute("data-id") });
    });
  }

  //社区志愿者
  let volunteerTemplate = require("./volunteer.art");
  getVolunteer({ PageSize: 5 });
  //获取社区志愿者
  function getVolunteer(data) {
    post("/ApiHome/ApiAction?_ControlName=GetVolunteerCallList", data).then(
      res => {
        if (res.Data.OnlyOneData && res.Data.OnlyOneData.length) {
          res.Data.OnlyOneData.forEach(item => {
            item.transMediaLength = setMediaLen(item.MediaLength);
          });
          var indexHtml = volunteerTemplate(res.Data);
          document.getElementById("km-volunteer-content").innerHTML = indexHtml;
        }
        var voiceList = document.getElementsByClassName("voice-box");
        // for (var i = 0; i < voiceList.length; i++) {
        //   voiceList[i].onclick = function() {
        //     //注意涉及到这个对象不能使用voiceList[i],要用this代替
        //     $("#audioPlayer").attr("src", this.getAttribute("data-media"));
        //     $("#audioPlayer")[0].play();
        //   };
        // }
      }
    );
  }

  // 语音交友
  let voiceTemplate = require("./voice_dating.art");
  //获取推荐语音交友
  getVoiceDating({ Position: 1010, PageSize: 5 });

  $("#voice-dating ul.km-service-type li").on("click", function () {
    var index = $(this).index();
    $(this)
      .addClass("active")
      .siblings()
      .removeClass("active");
    if (index == 0) {
      //推荐
      getVoiceDating({ Position: 1010, PageSize: 5 });
    } else if (index == 1) {
      //最新
      getVoiceDating({ Position: 1011, PageSize: 5 });
    }
  });

  //获取语音交友
  function getVoiceDating(data) {
    post("/ApiHome/ApiAction?_ControlName=GetVoiceFriendsCallList", data).then(
      res => {
        if (res.Data.OnlyOneData && res.Data.OnlyOneData.length) {
          res.Data.OnlyOneData.forEach(item => {
            item.transMediaLength = setMediaLen(item.MediaLength);
          });
          var indexHtml = voiceTemplate(res.Data);
          document.getElementById("km-voice-content").innerHTML = indexHtml;
        }
        var voiceList = document.getElementsByClassName("voice-box");
        // for (var i = 0; i < voiceList.length; i++) {
        //   voiceList[i].onclick = function() {
        //     //注意涉及到这个对象不能使用voiceList[i],要用this代替
        //     $("#audioPlayer").attr("src", this.getAttribute("data-media"));
        //     $("#audioPlayer")[0].play();
        //   };
        // }
      }
    );
  }

  //排行榜
  getWeekRanking();
  $("#ranking-list ul.km-ranking-type li").click(function () {
    $(this)
      .addClass("active")
      .siblings()
      .removeClass("active");
    var index = $(this).index();
    if (index == 0) {
      //周榜
      getWeekRanking();
    } else {
      //月榜
      getMonthRanking();
    }
  });

  function getWeekRanking() {
    let consultWeekly = {
      RankType: 2001, //咨询榜
      RankIndex: 1 //周榜
    };
    post("/ApiHome/ApiAction?_ControlName=GetUserRankByPC", consultWeekly).then(
      res => {
        const resD = res.Data.OnlyOneData.Data;
        if (resD) {
          var consultData = {};
          if (resD.length <= 3) {
            consultData["advisoryTopThree"] = resD.slice(0, 4);
            consultData["advisoryTopTen"] = [];
          } else {
            consultData["advisoryTopThree"] = resD.slice(0, 4);
            consultData["advisoryTopTen"] = resD.slice(4, 11);
          }
          let consultTemplate = require("./rankingTemplate/consultRanking.art");
          var rankingHtml = consultTemplate(consultData);
          document.getElementById(
            "consult-ranking-content"
          ).innerHTML = rankingHtml;
        }
      }
    );
    let expertWeekly = {
      RankType: 2002, //专家榜
      RankIndex: 1 //周榜
    };
    post("/ApiHome/ApiAction?_ControlName=GetUserRankByPC", expertWeekly).then(
      res => {
        const resD = res.Data.OnlyOneData.Data;
        if (resD) {
          var expertData = {};
          if (resD.length <= 3) {
            expertData["expertTopThree"] = resD.slice(0, 4);
            expertData["expertTopTen"] = [];
          } else {
            expertData["expertTopThree"] = resD.slice(0, 4);
            expertData["expertTopTen"] = resD.slice(4, 11);
          }
          let expertTemplate = require("./rankingTemplate/expertRanking.art");
          var rankingHtml = expertTemplate(expertData);
          document.getElementById(
            "expert-ranking-content"
          ).innerHTML = rankingHtml;
        }
      }
    );

    let giftWeekly = {
      RankType: 2003, //礼物榜
      RankIndex: 1 //周榜
    };
    post("/ApiHome/ApiAction?_ControlName=GetUserRankByPC", giftWeekly).then(
      res => {
        const resD = res.Data.OnlyOneData.Data;
        if (resD) {
          var giftData = {};
          if (resD.length <= 3) {
            giftData["giftTopThree"] = resD.slice(0, 4);
            giftData["giftTopTen"] = [];
          } else {
            giftData["giftTopThree"] = resD.slice(0, 4);
            giftData["giftTopTen"] = resD.slice(4, 11);
          }
          let expertTemplate = require("./rankingTemplate/giftRanking.art");
          var rankingHtml = expertTemplate(giftData);
          document.getElementById(
            "gift-ranking-content"
          ).innerHTML = rankingHtml;
        }
      }
    );
  }

  function getMonthRanking() {
    let consultMonthly = {
      RankType: 2001, //咨询榜
      RankIndex: 2 //周榜
    };
    post(
      "/ApiHome/ApiAction?_ControlName=GetUserRankByPC",
      consultMonthly
    ).then(res => {
      const resD = res.Data.OnlyOneData.Data;
      if (resD) {
        var consultData = {};
        if (resD.length <= 3) {
          consultData["advisoryTopThree"] = resD.slice(0, 4);
          consultData["advisoryTopTen"] = [];
        } else {
          consultData["advisoryTopThree"] = resD.slice(0, 4);
          consultData["advisoryTopTen"] = resD.slice(4, 11);
        }
        let consultTemplate = require("./rankingTemplate/consultRanking.art");
        var rankingHtml = consultTemplate(consultData);
        document.getElementById(
          "consult-ranking-content"
        ).innerHTML = rankingHtml;
      }
    });
    let expertMonthly = {
      RankType: 2002, //专家榜
      RankIndex: 2 //周榜
    };
    post("/ApiHome/ApiAction?_ControlName=GetUserRankByPC", expertMonthly).then(
      res => {
        const resD = res.Data.OnlyOneData.Data;
        if (resD) {
          var expertData = {};
          if (resD.length <= 3) {
            expertData["expertTopThree"] = resD.slice(0, 4);
            expertData["expertTopTen"] = [];
          } else {
            expertData["expertTopThree"] = resD.slice(0, 4);
            expertData["expertTopTen"] = resD.slice(4, 11);
          }
          let expertTemplate = require("./rankingTemplate/expertRanking.art");
          var rankingHtml = expertTemplate(expertData);
          document.getElementById(
            "expert-ranking-content"
          ).innerHTML = rankingHtml;
        }
      }
    );

    let giftMonthly = {
      RankType: 2003, //礼物榜
      RankIndex: 2 //周榜
    };
    post("/ApiHome/ApiAction?_ControlName=GetUserRankByPC", giftMonthly).then(
      res => {
        const resD = res.Data.OnlyOneData.Data;
        if (resD) {
          var giftData = {};
          if (resD.length <= 3) {
            giftData["giftTopThree"] = resD.slice(0, 4);
            giftData["giftTopTen"] = [];
          } else {
            giftData["giftTopThree"] = resD.slice(0, 4);
            giftData["giftTopTen"] = resD.slice(4, 11);
          }
          let expertTemplate = require("./rankingTemplate/giftRanking.art");
          var rankingHtml = expertTemplate(giftData);
          document.getElementById(
            "gift-ranking-content"
          ).innerHTML = rankingHtml;
        }
      }
    );
  }

  layui.use('flow', function () {
    let flow = layui.flow;
    flow.lazyimg();
  });

  let audioSetInterval;
  window.playVoice = function (el) {
    window.clearInterval(audioSetInterval);
    SetTimeL();
    let vblist = $(".voice-box");

    if (el.getAttribute("data-media") == $("#audioPlayer").attr("src")) {
      //同一个音频
      if ($(el).hasClass("pause")) {
        $(el)
          .removeClass("pause")
          .addClass("playing");
        $("#audioPlayer")[0].play();
        audioSetInterval = setInterval(Func, 1000);
      } else {
        $(el)
          .removeClass("playing")
          .addClass("pause");
        $("#audioPlayer")[0].pause();
      }
    } else {
      $(el)
        .removeClass("pause")
        .addClass("playing");
      $("#audioPlayer").attr("src", el.getAttribute("data-media"));
      $("#audioPlayer")[0].play();
      audioSetInterval = setInterval(Func, 1000);
    }
    if (vblist.length) {
      for (var i = 0; i < vblist.length; i++) {
        if (
          vblist[i].getAttribute("data-media") != $("#audioPlayer").attr("src")
        ) {
          $(vblist[i])
            .removeClass("playing")
            .addClass("pause");
        }
      }
    }

    function Func() {
      // 创建倒计时
      if (vblist.length) {
        for (var i = 0; i < vblist.length; i++) {
          if ($(vblist[i]).hasClass("playing")) {
            // 设置剩余时长
            let temp = Number(
              $(vblist[i])
                .find("label.timeL")
                .attr("data-ctime")
            );
            if (temp - 1 >= 0) {
              $(vblist[i])
                .find("label.timeL")
                .attr("data-ctime", temp - 1);
              $(vblist[i])
                .find("label.timeL")
                .text(setMediaLen(temp - 1));
            }
          }
        }
      }
    }

    function SetTimeL() {
      let vblist = $(".voice-box");
      if (vblist.length) {
        for (var i = 0; i < vblist.length; i++) {
          $(vblist[i])
            .find("label.timeL")
            .text(setMediaLen(vblist[i].getAttribute("data-time")));
        }
      }
    }
    var audio = document.getElementById("audioPlayer");
    if (audio) {
      audio.loop = false;
      audio.addEventListener(
        "ended",
        function () {
          console.log("结束");
          SetTimeL();
          //清除倒计时
          window.clearInterval(audioSetInterval);
          let vblist = $(".voice-box");
          if (vblist.length) {
            for (var i = 0; i < vblist.length; i++) {
              if (
                vblist[i].getAttribute("data-media") ==
                $("#audioPlayer").attr("src")
              ) {
                $(vblist[i])
                  .removeClass("playing")
                  .addClass("pause");
              }
            }
          }
          //在这个方法里写相应的逻辑就可以了
        },
        false
      );
    }
  };
});
